// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"_33974c2b58--checkbox--l9NIC","label":"_33974c2b58--label--wg3E4","box":"_33974c2b58--box--LEKeq","hasLabel":"_33974c2b58--hasLabel--uSvdq"};